import { Container, Box, Typography } from '@mui/material';

export default function PoliticaPrivacidade() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Box>
        <Typography variant="h4" component="h1" gutterBottom>
          Política de Privacidade – Better Lanches
        </Typography>

        <Typography variant="body1" paragraph>
          Esta Política de Privacidade descreve como a Better Lanches ("nós") coleta, utiliza e protege os dados
          pessoais dos usuários ("você") em nossa plataforma de pedidos on-line e canais integrados ao WhatsApp.
          Ao utilizar nossos serviços, você concorda com a coleta e uso das informações conforme descrito nesta
          política.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          1. Dados que coletamos
        </Typography>
        <Typography variant="body1" paragraph>
          Podemos coletar as seguintes informações:
        </Typography>
        <Typography variant="body1" component="div" sx={{ pl: 2 }}>
          <ul>
            <li>Dados de identificação: nome completo.</li>
            <li>Dados de contato: número de telefone (incluindo WhatsApp) e e-mail, quando informado.</li>
            <li>Dados de endereço: rua, número, bairro, cidade, ponto de referência e CEP, quando disponível.</li>
            <li>
              Dados de pedido: itens escolhidos, quantidades, observações, forma de pagamento, valores e
              histórico de pedidos.
            </li>
            <li>
              Dados técnicos: endereço IP, data e hora de acesso e informações básicas sobre o
              dispositivo/navegador, quando necessários para segurança e funcionamento do serviço.
            </li>
          </ul>
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          2. Como usamos seus dados
        </Typography>
        <Typography variant="body1" paragraph>
          Utilizamos os dados coletados para:
        </Typography>
        <Typography variant="body1" component="div" sx={{ pl: 2 }}>
          <ul>
            <li>Registrar e gerenciar seus pedidos.</li>
            <li>Entrar em contato com você sobre o status do pedido, dúvidas ou problemas.</li>
            <li>Realizar a entrega no endereço informado.</li>
            <li>Enviar comunicações transacionais relacionadas ao serviço.</li>
            <li>Cumprir obrigações legais e regulatórias.</li>
            <li>Melhorar a experiência e a segurança da nossa plataforma.</li>
          </ul>
        </Typography>

        <Typography variant="body1" paragraph>
          Não utilizamos seus dados para fins diferentes dos informados nesta política sem o seu consentimento.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          3. Compartilhamento de dados
        </Typography>
        <Typography variant="body1" paragraph>
          Podemos compartilhar seus dados pessoais apenas nas seguintes situações:
        </Typography>
        <Typography variant="body1" component="div" sx={{ pl: 2 }}>
          <ul>
            <li>
              Com estabelecimentos e parceiros responsáveis pelo preparo e entrega dos pedidos.
            </li>
            <li>
              Com provedores de serviços de tecnologia (como hospedagem, serviços de nuvem e ferramentas de envio de
              mensagens), apenas na medida necessária para a operação do serviço.
            </li>
            <li>
              Quando exigido por lei, ordem judicial ou autoridade competente.
            </li>
          </ul>
        </Typography>

        <Typography variant="body1" paragraph>
          Não vendemos, alugamos ou cedemos seus dados pessoais a terceiros para fins de marketing.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          4. WhatsApp e outros canais de comunicação
        </Typography>
        <Typography variant="body1" paragraph>
          Nosso serviço pode utilizar o WhatsApp ou outros canais para enviar confirmações de pedido, esclarecer
          dúvidas ou informar sobre problemas ou alterações no pedido. Ao informar seu número de telefone e utilizar
          nossa plataforma, você concorda em receber essas mensagens transacionais. Você pode solicitar a interrupção
          de comunicações não obrigatórias a qualquer momento.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          5. Base legal para o tratamento
        </Typography>
        <Typography variant="body1" paragraph>
          Tratamos seus dados pessoais com base em execução de contrato, cumprimento de obrigação legal, legítimo
          interesse (como melhoria de serviços e segurança) e consentimento, quando aplicável.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          6. Segurança dos dados
        </Typography>
        <Typography variant="body1" paragraph>
          Adotamos medidas técnicas e organizacionais razoáveis para proteger seus dados pessoais contra acessos não
          autorizados, perda, uso indevido ou divulgação indevida. No entanto, nenhum sistema é completamente seguro.
          Caso você identifique ou suspeite de qualquer uso indevido de seus dados, entre em contato conosco.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          7. Retenção de dados
        </Typography>
        <Typography variant="body1" paragraph>
          Manteremos seus dados pessoais apenas pelo tempo necessário para cumprir as finalidades descritas nesta
          política, atender exigências legais e regulatórias e resguardar direitos em eventuais processos. Após esse
          período, os dados poderão ser anonimizados ou excluídos de maneira segura.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          8. Seus direitos
        </Typography>
        <Typography variant="body1" paragraph>
          Nos termos da legislação aplicável (como a LGPD – Lei Geral de Proteção de Dados), você possui direitos
          como: confirmar se tratamos seus dados, acessar seus dados pessoais, corrigir dados incompletos, solicitar
          anonimização ou eliminação de dados desnecessários, revogar consentimento, entre outros. Para exercer seus
          direitos, utilize os canais de contato abaixo.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          9. Contato
        </Typography>
        <Typography variant="body1" paragraph>
          Em caso de dúvidas sobre esta Política de Privacidade ou sobre o tratamento de seus dados pessoais, entre
          em contato:
        </Typography>
        <Typography variant="body1" component="div" sx={{ pl: 2 }}>
          <ul>
            <li>E-mail: contato@betterdog.com.br</li>
            <li>Telefone/WhatsApp: (48) 99219-8889</li>
            <li>Endereço: Avenida Irere, Vilage Dunas - Balneário Gaivota/SC</li>
          </ul>
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          10. Atualizações desta política
        </Typography>
        <Typography variant="body1" paragraph>
          Esta Política de Privacidade pode ser atualizada periodicamente. A versão vigente estará sempre disponível
          nesta página. Recomendamos que você a consulte regularmente.
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
          Data da última atualização: 15/12/2025
        </Typography>
      </Box>
    </Container>
  );
}
